var exports = {
  "IA": "newsletter__5-VDgZ",
  "IM": "logoLink__uQwv2B",
  "wm": "logo__BfH7Od",
  "R_": "heading__nTH-6X",
  "G": "headingDot___XTmc-",
  "h_": "description__SMa0J2",
  "lO": "cta__qyyhvD",
};

module.exports = exports;
